<template>
  <div v-if="offer" class="offer-details-block">
    <div class="offer-details-box">
      <!-- Row 0: blocked candidate (v2) -->
      <ApplicantBlockBanner :applicant="offer.applicant" @released="onBlockReleased" />
      <!-- Row 1: Status | Score | Scales -->
      <div class="detail-row scales-score-status-row">
        <div class="status-with-badge">
          <offer-status v-if="offer.status" :payload="offer" buttonClass="status-button" @resolved="$emit('offer-resolved', $event)"></offer-status>
          <span v-if="isSystemStrong" class="badge reco-decision system-strong-badge">סטרונג מערכת – המלצת המערכת, ההחלטה שלך</span>
          <span
            v-if="screeningChip"
            class="badge reco-decision screening-chip"
            :class="screeningChip.cls"
            title="פירוט תשובות הסינון"
            @click.stop="screeningOpen = !screeningOpen"
          >{{ screeningChip.label }}<small v-if="offer.screening.stale" class="screening-stale"> (גרסה קודמת)</small></span>
        </div>
        <span v-if="offer.score !== null && offer.score !== undefined" class="score-value">{{ offer.score }}</span>
        <button-evaluate
          v-if="offer.applicant && offer.position"
          :payload="getEvaluatePayload()"
          class="scales-button"
        />
      </div>

      <div v-if="screeningChip && screeningOpen" class="screening-list" dir="rtl">
        <div v-for="(it, idx) in screeningItems" :key="idx" class="screening-item">
          <span class="screening-mark" :class="'mark-' + it.assessment">{{ it.mark }}</span>
          {{ it.text }} — {{ it.answerText }}
        </div>
      </div>

      <!-- Row 2: Message operator -->
      <div class="detail-row massage-offer-row clickable-message" @click="openMessageForm">
        <span class="detail-label message-label">אופר מסג'</span>
        <span class="message-content-block">{{ parsedMessage.content || 'אין הודעה' }}</span>
      </div>

      <!-- Row 3: Updated by | Date -->
      <div class="detail-row date-owner-row" v-if="offer.created_at || parsedMessage.owner">
        <div v-if="parsedMessage.owner" class="owner-section">
          <span class="detail-value">{{ parsedMessage.owner }}</span>
          <span class="detail-label">עודכן ע"י</span>
        </div>
        <div class="date-section">
          <span class="detail-value">{{ formatDate(offer.created_at) }}</span>
        </div>
      </div>

      <!-- Row 4: CV Buttons -->
      <div class="detail-row cv-buttons-row">
        <button @click="openSendCvModal" class="button is-primary is-small send-cv-inline" :class="{ 'is-blocked-control': isBlocked }" :title="isBlocked ? blockedToast : ''">
          <span>CV</span>
        </button>
        <button @click="clickedCvOther" class="button is-info is-small send-cv-other-inline" :class="{ 'is-blocked-control': isBlocked }" :title="isBlocked ? blockedToast : ''">
          <span>CV Other</span>
        </button>
        <button @click="aiEvaluate" class="button is-warning is-outlined is-small" title="הערכת AI">
          <span>AI</span>
        </button>
        <button
          @click="startConversationAnalysis"
          class="button is-small conversation-analysis-btn"
          title="ניתוח שיחת טלפון"
        >
          <span>ניתוח שיחה</span>
        </button>
        <button
          v-if="offerConversationId"
          @click="openChatbotPanel"
          class="button is-small chatbot-panel-btn"
          title="צפה בשיחה שהתקיימה עם המועמד על ההצעה"
        >
          <span>צפה בשיחה שהתקיימה עם המועמד על ההצעה</span>
        </button>
        <SubmissionConsentButton
          v-if="consentApplicantId"
          :applicantId="consentApplicantId"
          :offerId="offer.id || null"
          :positionId="consentPositionId"
          :companyId="consentCompanyId"
          :summary="offer.submission_consent_summary != null ? offer.submission_consent_summary : null"
          showUnknown
        />
        <a @click="openWhatsappTemplatesModal" class="whatsapp-templates-link" :class="{ 'is-blocked-control': isBlocked }" :title="isBlocked ? blockedToast : 'תבניות WhatsApp'">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 640 640" fill="#3273dc">
            <path d="M546.704 91.8909c-60.1779,-60.3078 -140.222,-93.4736 -225.475,-93.4736 -175.62,0 -318.559,142.951 -318.559,318.701 0,56.1385 14.7049,111.049 42.5675,159.297l-45.2368 165.179 168.959 -44.3391c46.5951,25.3822 99.013,38.8351 152.222,38.8351l0.129923 0c0,0 0,0 0,0 175.632,0 318.689,-142.951 318.689,-318.689 0,-85.1822 -33.1658,-165.179 -93.3437,-225.463l0.0472447 -0.0472447zm-225.381 490.423l0 0c-47.599,0 -94.2177,-12.8269 -134.895,-36.9571l-9.69697 -5.78747 -100.265 26.2562 26.7759 -97.7256 -6.27173 -10.0395c-26.6578,-42.095 -40.5714,-90.8161 -40.5714,-140.931 0,-146.081 118.832,-264.96 265.066,-264.96 70.7135,0 137.328,27.6499 187.302,77.623 49.9967,50.1266 77.4931,116.588 77.4931,187.42 -0.118112,146.187 -118.95,265.066 -264.96,265.066l0.0236223 0.0354335zm145.218 -198.463c-7.91348,-4.02761 -47.1148,-23.2326 -54.3904,-25.8901 -7.27568,-2.65751 -12.5789,-4.02761 -17.9766,4.02761 -5.26778,7.91348 -20.5869,25.8901 -25.2523,31.2642 -4.66541,5.27959 -9.28358,6.03551 -17.1971,2.0079 -7.91348,-4.02761 -33.6736,-12.4253 -64.0638,-39.5674 -23.6341,-21.0947 -39.6619,-47.2211 -44.3273,-55.1345 -4.66541,-7.91348 -0.519691,-12.3072 3.53154,-16.1931 3.66146,-3.54335 7.92529,-9.28358 11.9411,-13.949 4.02761,-4.66541 5.27959,-7.92529 7.92529,-13.3112 2.65751,-5.27959 1.35828,-9.945 -0.637803,-13.949 -2.0079,-4.0158 -17.9766,-43.2171 -24.4846,-59.1858 -6.38984,-15.6026 -13.0632,-13.4293 -17.9648,-13.701 -4.66541,-0.236223 -9.945,-0.236223 -15.201,-0.236223 -5.25597,0 -13.949,1.99609 -21.2247,9.93319 -7.27568,7.91348 -27.898,27.2602 -27.898,66.4496 0,39.2013 28.5122,77.0088 32.5161,82.4065 4.02761,5.26778 56.1621,85.7845 136.029,120.238 18.9805,8.16152 33.8036,13.0632 45.3549,16.8545 19.0987,6.0237 36.4256,5.14967 50.1266,3.12996 15.3191,-2.25593 47.1148,-19.2286 53.7881,-37.8312 6.6615,-18.6144 6.6615,-34.5359 4.66541,-37.8312 -1.88979,-3.54335 -7.15757,-5.504 -15.201,-9.57886l-0.0590558 0.0472447z"/>
          </svg>
        </a>
      </div>

      <!-- Position Recommendation AI Info (if available) -->
      <div v-if="recoData" class="reco-results-section">
        <div class="reco-header">
          <span class="reco-label">המלצת משרות AI:</span>
          <span class="badge reco-decision" :class="recoDecisionClass">{{ recoDecisionLabel }}</span>
        </div>
        <div v-if="recoData.ba_reasoning" class="reco-reasoning" v-html="sanitize(recoData.ba_reasoning)"></div>
      </div>

      <!-- AI Evaluation Results (inline) -->
      <div v-if="aiLoading" class="ai-results-section">
        <div class="ai-loading">
          <progress class="progress is-small is-warning" max="100"></progress>
          <span class="ai-loading-text">מריץ הערכת AI...</span>
        </div>
      </div>
      <div v-else-if="aiEvalData && aiEvalData.status === 'completed'" class="ai-results-section">
        <!-- Summarizer -->
        <div v-if="aiEvalData.summarizer" class="ai-summary-info">
          <div class="ai-summary-title">סיכום: <span class="ai-summary-status" :class="'ai-status-' + aiEvalData.summarizer.decision">{{ summaryStatus(aiEvalData.summarizer.decision) }}</span></div>
          <div class="ai-summary-content" v-html="sanitize(aiEvalData.summarizer.reasoning)"></div>
        </div>
        <!-- Missing Info -->
        <div v-if="aiEvalData.missing_info" class="ai-missing-info">
          <div class="ai-missing-title">צריך לשאול את המועמד</div>
          <ol class="ai-missing-list">
            <li v-for="(item, idx) in parseMissingItems(aiEvalData.missing_info.reasoning)" :key="idx" v-html="sanitize(item)"></li>
          </ol>
        </div>
      </div>
      <div v-else-if="aiEvalData && aiEvalData.status === 'error'" class="ai-results-section">
        <div class="ai-error">שגיאה: {{ aiEvalData.error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import OfferStatus from '@/components/OfferStatus.vue'
import ButtonEvaluate from '@/components/ButtonEvaluate.vue'
import SubmissionConsentButton from '@/components/SubmissionConsentButton.vue'
import ApplicantBlockBanner from '@/components/ApplicantBlockBanner.vue'
import { BLOCKED_TOAST, isApplicantBlocked, markReleased } from '@/custom/helpers/applicant_block.js'
import { mapMutations } from 'vuex'

export default {
  name: 'OfferDetailsBlock',
  components: {
    OfferStatus,
    ButtonEvaluate,
    SubmissionConsentButton,
    ApplicantBlockBanner
  },
  props: {
    offer: {
      type: Object,
      required: true,
      default: () => null
    },
    showEditButton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return { screeningOpen: false, blockedToast: BLOCKED_TOAST }
  },
  computed: {
    isBlocked () {
      return isApplicantBlocked(this.offer && this.offer.applicant)
    },
    // R1.3 - ids for the consent evidence button; tolerant to the payload shape.
    consentApplicantId () {
      const a = this.offer && this.offer.applicant
      const id = (a && (a.resource_id || a.id)) || (this.offer && this.offer.applicant_id)
      return id ? Number(id) : null
    },
    consentPositionId () {
      const p = this.offer && this.offer.position
      const id = (p && (p.resource_id || p.id)) || (this.offer && this.offer.position_id)
      return id ? Number(id) : null
    },
    consentCompanyId () {
      const p = this.offer && this.offer.position
      const c = p && p.company
      const id = (c && (c.resource_id || c.id)) || (p && p.company_id)
      return id ? Number(id) : null
    },
    recoData () {
      if (!this.offer || !this.offer.id) return null
      const applicantId = this.offer.applicant
        ? (this.offer.applicant.resource_id || this.offer.applicant.id)
        : null
      if (!applicantId) return null
      const allResults = this.$store.getters['positionRecommendations/getAllResults'](applicantId)
      if (!allResults || !allResults.length) return null
      return allResults.find(r => r.offer_id === this.offer.id) || null
    },
    isSystemStrong () {
      return !!(this.offer && this.offer.status && this.offer.status.name === 'system_strong')
    },
    recoDecisionClass () {
      if (!this.recoData) return ''
      return {
        'reco-green': this.recoData.ba_decision === 'green',
        'reco-orange': this.recoData.ba_decision === 'orange',
        'reco-red': this.recoData.ba_decision === 'red' || this.recoData.ba_decision === 'error'
      }
    },
    recoDecisionLabel () {
      if (!this.recoData) return ''
      const labels = { green: 'עובר', orange: 'לבדוק', red: 'לא מתאים', error: 'שגיאה' }
      return labels[this.recoData.ba_decision] || this.recoData.ba_decision || '-'
    },
    aiLoading () {
      if (!this.offer || !this.offer.id) return false
      return this.$store.getters['aiEvaluation/isLoading'](this.offer.id)
    },
    aiEvalData () {
      if (!this.offer || !this.offer.id) return null
      return this.$store.getters['aiEvaluation/getEvaluation'](this.offer.id)
    },
    offerApplicantId () {
      const a = this.offer && this.offer.applicant
      return a ? (a.resource_id || a.id) : null
    },
    offerConversationId () {
      if (!this.offer) return null
      const positionId = this.offer.position ? this.offer.position.id : null
      return this.$store.getters['offerConversations/getConvId'](
        this.offerApplicantId, this.offer.id, positionId
      )
    },
    screeningChip () {
      const sc = this.offer && this.offer.screening
      if (!sc) return null
      if (sc.state === 'in_progress') return { label: 'סינון: בתהליך', cls: 'screening-grey' }
      if (sc.state === 'incomplete') return { label: 'סינון: חלקי', cls: 'reco-orange' }
      switch (sc.outcome) {
        case 'pass': return { label: 'סינון: תואם', cls: 'reco-green' }
        case 'must_fail': return { label: 'סינון: תנאי חובה ✗', cls: 'reco-red' }
        case 'review': return { label: 'סינון: לבדיקה', cls: 'reco-orange' }
        case 'information_only': return { label: 'סינון: נשמר', cls: 'screening-blue' }
        default: return null
      }
    },
    screeningItems () {
      const sc = this.offer && this.offer.screening
      const marks = { pass: '✓', fail: '✗', unknown: '?', not_applicable: '•' }
      const answers = { yes: 'כן', no: 'לא', unclear: 'לא ברור', not_answered: 'לא נענה' }
      return ((sc && sc.items) || []).map(it => {
        const base = it.assessment === 'not_applicable' ? (it.detail || answers[it.answer] || '') : (answers[it.answer] || it.answer || '')
        const extra = it.assessment !== 'not_applicable' && it.detail ? ', ' + it.detail : ''
        return {
          text: it.text,
          assessment: it.assessment,
          mark: marks[it.assessment] || '?',
          answerText: (base + extra) || 'לא נענה'
        }
      })
    },
    parsedMessage () {
      if (!this.offer || !this.offer.message) {
        return { content: '', hasMetadata: false }
      }

      const message = this.offer.message

      // Try to extract metadata using regex
      const dateMatch = message.match(/<message-date>(.*?)<\/message-date>/i)
      const ownerMatch = message.match(/<owner>(.*?)<\/owner>/i)

      if (dateMatch || ownerMatch) {
        // Remove metadata tags from content - handle both correct and typo spellings
        // Also remove any leftover tags that might be visible
        let content = message
          .replace(/<messsage-meta>.*?<\/messsage-meta>/gis, '')
          .replace(/<message-meta>.*?<\/message-meta>/gis, '')
          .replace(/<message-date>.*?<\/message-date>/gis, '')
          .replace(/<owner>.*?<\/owner>/gis, '')
          .trim()

        return {
          content: content || 'אין הודעה',
          hasMetadata: true,
          date: dateMatch ? dateMatch[1] : null,
          owner: ownerMatch ? ownerMatch[1] : null
        }
      }

      return { content: message, hasMetadata: false }
    }
  },
  watch: {
    offer: {
      handler (newOffer) {
        if (newOffer && newOffer.id && !this.aiEvalData && !this.aiLoading) {
          this.fetchAiEvaluation()
        }
      },
      immediate: false
    }
  },
  mounted () {
    if (this.offer && this.offer.id && !this.aiEvalData) {
      this.fetchAiEvaluation()
    }
    if (this.offerApplicantId) {
      this.$store.dispatch('offerConversations/fetchForApplicant', {
        applicantId: this.offerApplicantId,
        vm: this
      })
    }
  },
  methods: {
    onBlockReleased () {
      markReleased(this, this.offer && this.offer.applicant)
    },
    fetchAiEvaluation () {
      if (!this.offer || !this.offer.id) return
      this.$store.dispatch('aiEvaluation/fetchEvaluation', {
        offerId: this.offer.id,
        vm: this
      })
    },
    sanitize (text) {
      if (!text) return ''
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/&lt;b&gt;/g, '<b>').replace(/&lt;\/b&gt;/g, '</b>')
        .replace(/&lt;i&gt;/g, '<i>').replace(/&lt;\/i&gt;/g, '</i>')
        .replace(/&lt;br\s*\/?&gt;/g, '<br>')
        .replace(/\n/g, '<br>')
    },
    parseMissingItems (reasoning) {
      if (!reasoning) return []
      return reasoning
        .split(/\n|(?:\d+\.\s)/)
        .map(s => s.replace(/^[-•*]\s*/, '').trim())
        .filter(s => s.length > 0)
    },
    summaryStatus (decision) {
      const labels = { green: 'עובר', red: 'לא עובר', orange: 'צריך לברר עוד מידע' }
      return labels[decision] || decision
    },
    /**
     * Get payload for ButtonEvaluate component
     * Ensures all required fields are present
     */
    getEvaluatePayload () {
      if (!this.offer || !this.offer.applicant || !this.offer.position) {
        return null
      }

      const applicant = this.offer.applicant
      const position = this.offer.position

      // Ensure full_name exists
      const fullName = applicant.full_name ||
        `${applicant.first_name || ''} ${applicant.last_name || ''}`.trim() ||
        'N/A'

      return {
        applicant: {
          ...applicant,
          full_name: fullName
        },
        position: {
          ...position,
          company: position.company || { name: 'N/A' }
        }
      }
    },

    formatDate (dateString) {
      if (!dateString) return 'N/A'
      return this.$moment(dateString).format('DD/MM/YYYY HH:mm')
    },

    /**
     * Open Send CV Modal
     */
    openSendCvModal () {
      if (!this.offer) return
      if (this.isBlocked) {
        this.$utils.emit('show_toast', { text: BLOCKED_TOAST })
        return
      }

      this.create({
        designator: 'send-cv-mode-selection-modal',
        component_name: 'SendCvModeSelectionModal',
        data: this.offer,
        modal_title: 'בחירת מצב שליחת קורות חיים',
        modal_width: 600,
        is_center_modal: true
      })
    },

    /**
     * Clicked CV Other - Opens position search modal to select a different position
     */
    clickedCvOther () {
      if (!this.offer) return
      if (this.isBlocked) {
        this.$utils.emit('show_toast', { text: BLOCKED_TOAST })
        return
      }

      this.$store.commit('modals/create', {
        designator: 'position-search-for-cv-modal',
        component_name: 'PositionSearchForCvModal',
        modal_title: 'בחירת משרה לשליחת קו"ח',
        modal_width: 800,
        is_center_modal: true,
        offer: this.offer,
        onPositionSelected: (selectedPosition) => {
          this.openSendCvModalForOtherPosition(this.offer, selectedPosition)
        }
      })
    },

    /**
     * Open Send CV Modal for a different position
     */
    async openSendCvModalForOtherPosition (currentOffer, selectedPosition) {
      try {
        // Try to find or create offer for the applicant + new position
        const offer = await this.findOrCreateOffer(
          currentOffer.applicant.resource_id || currentOffer.applicant.id,
          selectedPosition.id
        )

        // Open SendCvModeSelectionModal with the offer
        this.$store.commit('modals/create', {
          designator: 'send-cv-mode-selection-modal',
          component_name: 'SendCvModeSelectionModal',
          data: offer,
          modal_title: 'בחירת מצב שליחת קורות חיים',
          modal_width: 600,
          is_center_modal: true
        })
      } catch (error) {
        console.error('Error opening CV modal:', error)
        this.$utils.emit('show_toast', { text: 'שגיאה בטעינת/יצירת ההצעה' })
      }
    },

    /**
     * Find or create offer for applicant + position combination
     */
    async findOrCreateOffer (applicantId, positionId) {
      try {
        // Fetch the position and applicant data directly
        // Avoid using getResourceOffers which is being blocked/rate-limited in production
        const position = await this.$network_utils.getPosition({ id: positionId })
        const applicant = await this.$network_utils.getApplicant({ id: applicantId })

        // Create a virtual offer object that will work with SendCvModeSelectionModal
        // The modal will handle creating the actual offer when needed
        const virtualOffer = {
          id: `temp_${Date.now()}`,
          applicant: applicant,
          position: position,
          status: { name: 'awaiting_applicant' },
          message: '',
          is_virtual: true
        }

        return virtualOffer
      } catch (error) {
        console.error('Error finding/creating offer:', error)
        throw error
      }
    },

    /**
     * Open MessageForm modal for editing offer message
     */
    openMessageForm () {
      if (!this.offer) return

      this.create({
        designator: 'message-modal',
        component_name: 'MessageForm',
        resource_data: this.offer,
        additional_data: {
          resource_type: 'Offer',
          endpoint: 'offers',
          headers: 'admin_headers'
        },
        is_submitable: true,
        modal_title: 'Message - Offer #' + this.offer.id
      })
    },

    aiEvaluate () {
      if (!this.offer || !this.offer.id) return

      this.create({
        designator: 'ai-evaluation-modal-' + this.offer.id,
        component_name: 'AiEvaluationModal',
        data: this.offer,
        modal_title: 'הערכת AI',
        modal_width: 700,
        is_center_modal: true
      })
    },

    openWhatsappTemplatesModal () {
      if (!this.offer || !this.offer.id) return
      if (this.isBlocked) {
        this.$utils.emit('show_toast', { text: BLOCKED_TOAST })
        return
      }

      this.create({
        designator: 'whatsapp-templates-modal-' + this.offer.id,
        component_name: 'ModalOfferWhatsappTemplates',
        modal_title: 'הצעת משרה למועמד',
        modal_width: 900,
        is_center_modal: true,
        data: {
          id: this.offer.id,
          applicant: this.offer.applicant,
          position: this.offer.position,
          company: this.offer.position && this.offer.position.company
        }
      })
    },

    /**
     * Open the chatbot test panel showing only this offer's conversation.
     * Button is hidden when no conversation matches the offer.
     * The conversation is resolved by matching the offer/position id against
     * each conversation's offer_ids (offerConversations store). applicant_id is
     * passed too so the panel can resolve the header (name/phone).
     */
    openChatbotPanel () {
      const convId = this.offerConversationId
      if (!convId) return
      const base = 'https://chatbot.test.panel.hasama.online'
      let url = `${base}?conversation_id=${convId}&readonly=true`
      if (this.offerApplicantId) url += `&applicant_id=${this.offerApplicantId}`
      window.open(url, '_blank')
    },

    startConversationAnalysis () {
      if (!this.offer || !this.offer.applicant) return

      var self = this
      var applicantId = this.offer.applicant.resource_id || this.offer.applicant.id

      this.create({
        designator: 'conversation-analysis-modal',
        component_name: 'ConversationAnalysisModal',
        modal_width: 1100,
        is_center_modal: true,
        modal_title: 'ניתוח שיחת טלפון',
        props: {
          applicantId: applicantId,
          offerId: self.offer.id,
          onComplete: function () {
            self.$store.commit('modals/removeModalByDesignator', 'conversation-analysis-modal')
          }
        }
      })
    },

    ...mapMutations('modals', ['create'])
  }
}
</script>

<style scoped>
.is-blocked-control {
  opacity: 0.4;
  filter: grayscale(100%);
  cursor: not-allowed;
}
.offer-details-block {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 0.25rem;
  margin-bottom: 0.5rem;
  border: 4px solid #2c3e50;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15), 0 0 0 2px rgba(44, 62, 80, 0.1);
}

.offer-details-box {
  background-color: transparent;
  border-radius: 0;
  padding: 0.2rem 0;
  margin: 0;
  border: none;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem 0.4rem;
  margin-bottom: 0.15rem;
  background-color: transparent;
  border-radius: 0;
  border: none;
  transition: all 0.2s ease;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.detail-label {
  font-weight: 700;
  color: #2c3e50;
  margin-left: 0.3rem;
  font-size: 0.85rem;
}

.detail-value {
  color: #4a4a4a;
  font-weight: 500;
  font-size: 0.85rem;
}

/* Status Button Styling */
.status-button {
  padding: 0.25rem 0.6rem;
  font-size: 0.8rem;
  border-radius: 4px;
  color: white !important;
  cursor: pointer;
  transition: opacity 0.2s ease;
  text-decoration: none;
  display: inline-block;
}

.status-button:hover {
  opacity: 0.85;
}

/* Scales Score Status Row */
.scales-score-status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.score-value {
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  font-weight: 700;
  font-size: 0.85rem;
  border: 2px solid #1976d2;
}

.scales-button {
  flex-shrink: 0;
}

/* Massage Offer Row */
.massage-offer-row {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.15rem;
  padding: 0.2rem 0.4rem;
  background-color: transparent;
}

.message-label {
  font-weight: 700;
  color: #2c3e50;
  font-size: 0.85rem;
  margin: 0;
}

.message-content-block {
  width: 100%;
  color: #2c3e50;
  font-size: 0.85rem;
  line-height: 1.3;
  word-break: break-word;
  font-weight: 500;
  text-align: right;
  white-space: pre-line;
}

.edit-icon-btn {
  flex-shrink: 0;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.edit-icon-btn:hover {
  transform: scale(1.05);
  background-color: #209cee;
}

/* Date Owner Row */
.date-owner-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.owner-section,
.date-section {
  display: flex;
  gap: 0.2rem;
  align-items: center;
}

/* CV Buttons Row */
.cv-buttons-row {
  display: flex;
  gap: 0.3rem;
  justify-content: flex-start;
  align-items: center;
}

.send-cv-inline,
.send-cv-other-inline {
  flex-shrink: 0;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.send-cv-inline:hover,
.send-cv-other-inline:hover {
  transform: scale(1.05);
  opacity: 0.9;
}

.whatsapp-templates-link {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.whatsapp-templates-link:hover {
  transform: scale(1.1);
}

.conversation-analysis-btn {
  white-space: nowrap;
  background-color: #00897b !important;
  color: white !important;
  border-color: #00897b !important;
  font-size: 0.75rem !important;
}

.conversation-analysis-btn:hover:not(:disabled) {
  background-color: #00796b !important;
  transform: scale(1.05);
}

.conversation-analysis-btn:disabled {
  opacity: 0.6;
}

.chatbot-panel-btn {
  white-space: nowrap;
  background-color: #3273dc !important;
  color: white !important;
  border-color: #3273dc !important;
  font-size: 0.75rem !important;
}

.chatbot-panel-btn:hover {
  background-color: #2366d1 !important;
  transform: scale(1.05);
}

/* Clickable Message */
.clickable-message {
  cursor: pointer;
}

.clickable-message:hover {
  background-color: #e8f4f8 !important;
  border-radius: 4px;
}

/* Position Recommendation Results */
.reco-results-section {
  margin-top: 0.3rem;
  padding: 0.4rem;
  background: #f5f0ff;
  border-radius: 4px;
  border: 1px solid #d4c5f0;
  direction: rtl;
  text-align: right;
}

.reco-header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.25rem;
}

.reco-label {
  font-size: 0.8rem;
  font-weight: 700;
  color: #2c3e50;
}

.reco-decision {
  padding: 0.1rem 0.5rem;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 700;
  color: white;
}

.reco-green { background-color: #48c774; }
.reco-orange { background-color: #ff9f43; }
.reco-red { background-color: #f14668; }

.status-with-badge {
  display: flex;
  align-items: center;
  gap: 6px;
}

.system-strong-badge { background-color: purple; }
.screening-chip { cursor: pointer; }
.screening-grey { background-color: #7a7a7a; }
.screening-blue { background-color: #3273dc; }
.screening-stale { font-weight: 400; font-size: 0.65rem; }
.screening-list {
  margin: 0.2rem 0;
  padding: 0.3rem 0.5rem;
  background: #f7f7f7;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  font-size: 0.78rem;
  line-height: 1.4;
  text-align: right;
}
.screening-mark { font-weight: 700; margin-left: 4px; }
.mark-pass { color: #257942; }
.mark-fail { color: #cc0f35; }
.mark-unknown { color: #b86e00; }

.reco-reasoning {
  font-size: 0.75rem;
  color: #4a4a4a;
  line-height: 1.4;
  word-break: break-word;
}

/* AI Results Section */
.ai-results-section {
  margin-top: 0.3rem;
  padding: 0.3rem 0.4rem;
  border-top: 1px solid #dee2e6;
}

.ai-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
}

.ai-loading .progress {
  width: 100%;
  height: 0.4rem;
  margin: 0;
}

.ai-loading-text {
  font-size: 0.75rem;
  color: #888;
}

.ai-result-row {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  gap: 0.4rem;
  margin-bottom: 0.3rem;
  direction: rtl;
  text-align: right;
}

.ai-result-row:last-child {
  margin-bottom: 0;
}

.ai-decision-badge {
  flex-shrink: 0;
  padding: 0.1rem 0.4rem;
  border-radius: 3px;
  font-size: 0.7rem;
  font-weight: 700;
  color: white;
  white-space: nowrap;
}

.ai-decision-red {
  background-color: #dc3545;
}

.ai-decision-orange {
  background-color: #fd7e14;
}

.ai-decision-green {
  background-color: #28a745;
}

.ai-result-label {
  flex-shrink: 0;
  font-weight: 700;
  font-size: 0.75rem;
  color: #2c3e50;
}

.ai-result-text {
  font-size: 0.75rem;
  color: #4a4a4a;
  line-height: 1.3;
  word-break: break-word;
}

.ai-summary-info {
  direction: rtl;
  text-align: right;
}

.ai-summary-title {
  font-size: 0.75rem;
  font-weight: 700;
  color: #2c3e50;
}

.ai-summary-status {
  font-weight: 700;
}

.ai-status-green {
  color: #28a745;
}

.ai-status-orange {
  color: #fd7e14;
}

.ai-status-red {
  color: #dc3545;
}

.ai-summary-content {
  font-size: 0.75rem;
  color: #4a4a4a;
  line-height: 1.3;
  word-break: break-word;
}

.ai-missing-info {
  margin-top: 0.2rem;
  direction: rtl;
  text-align: right;
}

.ai-missing-title {
  font-size: 0.75rem;
  font-weight: 700;
  color: #2c3e50;
}

.ai-missing-list {
  font-size: 0.75rem;
  color: #4a4a4a;
  line-height: 1.4;
  margin: 0.15rem 0 0 0;
  padding-right: 1.2rem;
  padding-left: 0;
}

.ai-error {
  font-size: 0.75rem;
  color: #dc3545;
  text-align: right;
  direction: rtl;
}
</style>
